import { Model, Collection } from '@/models/BaseModel';

import {
    equal,
    integer,
    min,
    required,
    string,
    email,
    boolean
} from 'vue-mc/validation';

export class Customer extends Model {
    public options() {
        return {
            identifier: 'id'
        };
    }

    public defaults() {
        return {
            id: null,
            first_name: '',
            last_name: '',
            email: '',
        };
    }

    public mutations() {
        return {
            id: (id: any) => Number(id) || null,
            first_name: String,
            last_name: String,
            email: String,
        };
    }

    public validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            first_name: string.and(required),
            last_name: string.and(required),
            email: email.and(required),
        };
    }

    public routes() {
        return {
            fetch: "customers/{id}",
            save: "customers",
            delete: "customers/{id}"
        };
    }
}

export class CustomerCollection extends Collection {
    public model() {
        return Customer;
    }

    public defaults() {
        return {
            orderBy: 'first_name',
        };
    }

    public routes() {
        return {
            fetch: "customers",
        };
    }

    public fetchData() {
        return this.fetch();
    }
}
